const ENTERING_DURATION = 500;
const EXITING_DURATION = 500;

export const DEFAULT_TRANSITION_DURATION = {
  enter: ENTERING_DURATION,
  exit: EXITING_DURATION,
};
